import luda from '../base/luda.coffee'
import './eq.coffee'


luda.include
  
  first: -> @eq 0